

export default {
  name: "navBar",
  components: {},
  props: {
    hoverTitle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      hoverActive: ''
    }
  },
  watch: {
    hoverTitle (newVal) {
      if (this.$t(newVal) == this.$t('nav["Coretechnology"]')) {
        this.hoverActive = 1
      } else if (this.$t(newVal) == this.$t('nav["Applicationintroduction"]')) {
        this.hoverActive = 2
      } else if (this.$t(newVal) == this.$t('nav["Servicecase"]')) {
        this.hoverActive = 3
      } else {
        this.hoverActive = ''
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    getRouter(path) {
      const locale = this.$i18n.locale;
      const pre = (locale == 'en' ? '/en' : '');
      return pre + path;
    }
  }
}
